import { AssetVersionModel } from "lib/types/assets/AssetVersionModel";

export function formatVersionLabel(version: AssetVersionModel): string {
  const prefix = version.prefix ? version.prefix : "V";
  const major = version.major ? version.major.toString() : "0";
  const minor = version.minor ? "." + version.minor.toString() : "";
  return `${prefix}${major}${minor}`;
}
